import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { CreateProps } from '../shared/CreateProps'
import AddIcon from '@mui/icons-material/AddCircleOutline'
import ElectricityIcon from '@mui/icons-material/FlashOn'
import { useAuth } from '../../context/useAuth'
import Typography from '@mui/material/Typography'

export default function CreateElDemand({ disabled, schema, setData }: CreateProps) {
	const { name } = useParams()
	const { csrf } = useAuth()
	const [error, setError] = React.useState<any>(undefined)
	const [open, setOpen] = React.useState(false)

	return (
		<ButtonDialog
			disabled={disabled}
			title={`Add Electricity Demand`}
			icon={<ElectricityIcon />}
			iconButton={<AddIcon fontSize='small' color={disabled ? 'disabled' : 'primary'} />}
			content={
				<>
				<Typography variant='caption' color='error' sx={{ mx: 2, mt: -1 }}>
				{error || ''}
				</Typography>
				<Form
					showErrorList={false}
					transformErrors={(errors: any) => {
						return errors.map((error: any) => {
							if (error.name === 'pattern') error.message = 'Invalid name'
							return error
						})
					}}
					onSubmit={async (e) => {
						try {
							const res = await axios.post(
								`${process.env.REACT_APP_API}/${name}/eldemand`,
								JSON.stringify(e.formData),
								{
									headers: {
										'Content-Type': 'application/json',
										'X-CSRFToken': csrf
									},
									withCredentials: true
								}
							)
							setData(res.data)
							setOpen(false)
						} catch (err) {
							console.log('err:', err)
							if ((err as any)?.response?.data?.error) {
								setError((err as any).response.data.error);
							  } else {
								setError("An unknown error occurred."); // Handle unknown errors
							  } 
						}
					}}
					validator={validator}
					schema={schema as JSONSchema7}
				/>
				</>
			}
			open={open}
			setOpen={setOpen}
		/>
	)
}
